import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.model-cards' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--model-cards' )[0], {
          pagination: false,
          arrows: false,
          gap: '32px',
          perPage: 2,
          perMove: 1,
          breakpoints: {
            767: {
              perPage: 1,
            },
          },
        } );

        const applyOverflowState = ( isOverflow ) => {
          const root = splide.root;

          if ( !isOverflow ) {
            // Go static
            splide.options = {type: 'slide', arrows: false, drag: false};
            root.classList.add( 'is-static' );
          } else {
            // Re-activate slider
            splide.options = {type: 'loop', arrows: true, drag: true};
            root.classList.remove( 'is-static' );
          }
        };

        // Fires on mount/refresh when Splide recalculates layout
        splide.on( 'overflow', applyOverflowState );

        // Debounced refresh so we don't thrash on continuous resize
        let rafId;
        const refresh = () => {
          if ( rafId ) cancelAnimationFrame( rafId );
          rafId = requestAnimationFrame( () => splide.refresh() );
        };

        // Splide emits 'resize' itself; also handle 'updated'
        splide.on( 'resize', refresh );
        splide.on( 'updated', refresh );

        // Also listen for CSS breakpoint crossings (helps some layouts)
        [window.matchMedia( '(max-width: 1024px)' ),
          window.matchMedia( '(max-width: 768px)' )].forEach( ( mq ) => {
          mq.addEventListener( 'change', refresh );
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'model-cards', COMPONENT );
} )( app );
